import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../service/caller';
import './repport.css';
import { Bar } from 'recharts';
import PatientTrends from './patient';
import Service from './service';
import { BarChart, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CTab,
  CTabContent,
  CTabList,
  CTabPanel,
  CTabs,
  CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter
} from '@coreui/react';
import { FaRedoAlt, FaExchangeAlt, FaFilter, FaSearch, FaDownload, FaFolderOpen, FaFileInvoiceDollar } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft, BsArrowDownUp } from 'react-icons/bs';
import Adminprofil from '../../assets/images/adminprofil.png';

const HospitalDashboard = () => {

  const [UserData, setUserData] = useState([]);
  const [activeTab, setActiveTab] = useState('Patient Trends');

  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);

  const detailsData = {
    'Décès': {
      data: [
        { month: 'Jan', volume: 10 },
        { month: 'Fev', volume: 15 },
        { month: 'Mar', volume: 12 },
        { month: 'Apr', volume: 55 },
        { month: 'May', volume: 60 },
        { month: 'Jun', volume: 65 },
        { month: 'Jul', volume: 70 },
        { month: 'Aug', volume: 75 },
        { month: 'Sep', volume: 80 },
        { month: 'Oct', volume: 85 },
        { month: 'Nov', volume: 90 },
        { month: 'Dec', volume: 95 }
      ],
      color: '#FF6384'
    },
    'Consultation': {
      data: [
        { month: 'Jan', volume: 120 },
        { month: 'Fev', volume: 135 },
        { month: 'Mar', volume: 125 },
        { month: 'Apr', volume: 55 },
        { month: 'May', volume: 60 },
        { month: 'Jun', volume: 65 },
        { month: 'Jul', volume: 70 },
        { month: 'Aug', volume: 75 },
        { month: 'Sep', volume: 80 },
        { month: 'Oct', volume: 85 },
        { month: 'Nov', volume: 90 },
        { month: 'Dec', volume: 95 }
      ],
      color: '#36A2EB'
    },
    'Accouchements': {
      data: [
        { month: 'Jan', volume: 50 },
        { month: 'Fev', volume: 55 },
        { month: 'Mar', volume: 60 },
        { month: 'Apr', volume: 55 },
        { month: 'May', volume: 60 },
        { month: 'Jun', volume: 65 },
        { month: 'Jul', volume: 70 },
        { month: 'Aug', volume: 75 },
        { month: 'Sep', volume: 80 },
        { month: 'Oct', volume: 85 },
        { month: 'Nov', volume: 90 },
        { month: 'Dec', volume: 95 }
      ],
      color: '#4BC0C0'
    },
    'Consultation effectuée': {
      data: [
        { month: 'Jan', volume: 80 },
        { month: 'Fev', volume: 90 },
        { month: 'Mar', volume: 85 },
        { month: 'Apr', volume: 55 },
        { month: 'May', volume: 60 },
        { month: 'Jun', volume: 65 },
        { month: 'Jul', volume: 70 },
        { month: 'Aug', volume: 75 },
        { month: 'Sep', volume: 80 },
        { month: 'Oct', volume: 85 },
        { month: 'Nov', volume: 90 },
        { month: 'Dec', volume: 95 }
      ],
      color: '#FFCE56'
    },
    'Demande de laboratoire': {
      data: [
        { month: 'Jan', volume: 40 },
        { month: 'Fev', volume: 45 },
        { month: 'Mar', volume: 50 },
        { month: 'Apr', volume: 55 },
        { month: 'May', volume: 60 },
        { month: 'Jun', volume: 65 },
        { month: 'Jul', volume: 70 },
        { month: 'Aug', volume: 75 },
        { month: 'Sep', volume: 80 },
        { month: 'Oct', volume: 85 },
        { month: 'Nov', volume: 90 },
        { month: 'Dec', volume: 95 }
      ],
      color: '#9966FF'
    },
    'Annulation de consultation': {
      data: [
        { month: 'Jan', volume: 20 },
        { month: 'Fev', volume: 25 },
        { month: 'Mar', volume: 22 },
        { month: 'Apr', volume: 55 },
        { month: 'May', volume: 60 },
        { month: 'Jun', volume: 65 },
        { month: 'Jul', volume: 70 },
        { month: 'Aug', volume: 75 },
        { month: 'Sep', volume: 80 },
        { month: 'Oct', volume: 85 },
        { month: 'Nov', volume: 90 },
        { month: 'Dec', volume: 95 }
      ],
      color: '#FF9F40'
    },
    'Prescriptions issues par doctors': {
      data: [
        { month: 'Jan', volume: 60 },
        { month: 'Fev', volume: 70 },
        { month: 'Mar', volume: 65 },
        { month: 'Apr', volume: 55 },
        { month: 'May', volume: 60 },
        { month: 'Jun', volume: 65 },
        { month: 'Jul', volume: 70 },
        { month: 'Aug', volume: 75 },
        { month: 'Sep', volume: 80 },
        { month: 'Oct', volume: 85 },
        { month: 'Nov', volume: 90 },
        { month: 'Dec', volume: 95 }
      ],
      color: '#13D3C3'
    },
    'Diagnostic par type de maladie': {
      data: [
        { month: 'Jan', volume: 30 },
        { month: 'Fev', volume: 35 },
        { month: 'Mar', volume: 40 },
        { month: 'Apr', volume: 55 },
        { month: 'May', volume: 60 },
        { month: 'Jun', volume: 65 },
        { month: 'Jul', volume: 70 },
        { month: 'Aug', volume: 75 },
        { month: 'Sep', volume: 80 },
        { month: 'Oct', volume: 85 },
        { month: 'Nov', volume: 90 },
        { month: 'Dec', volume: 95 }
      ],
      color: '#F44336'
    }
  };

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch user profile data");
      }
    };
    fetchLoggedUserData();
  }, []);

  const toggleSettings = () => {
    setIsSettingsOpen(!isSettingsOpen);
  };

  const handleDetailSelect = (detail) => {
    setSelectedDetail(detail);
    setIsSettingsOpen(false);
  };
  return (
    <div>
      <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
        <div className="hosp-header__content">
          {/* Titre à gauche */}
          <div className="hosp-header__title">
            <h4 className="hosp-page__title"><b>Repports & Analytics</b></h4>
          </div>

          {/* Profil utilisateur à droite */}
          <div className="hosp-user__profile">
            {/* Indicateur de statut en ligne (optionnel) */}
            <div className="hosp-status__indicator"></div>

            <img
              src={UserData?.picture || Adminprofil}
              className='hosp-profile__image'
              alt="Profile Icon"
            />

            <div className="hosp-user__details">
              <span className="hosp-user__name">{UserData.firstname} {UserData.lastname}</span>
              <p className="hosp-user__role">
                {UserData.role?.name}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="hospital-dashboard">
        <div className="dashboard-tabs">

          <button
            className={`tab-button ${activeTab === 'Patient Trends' ? 'active' : ''}`}
            onClick={() => setActiveTab('Patient Trends')}
          >
            Patient Trends
          </button>
          <button
            className={`tab-button ${activeTab === 'Use Service' ? 'active' : ''}`}
            onClick={() => setActiveTab('Use Service')}
          >
            Appointment heatmap
          </button>
        </div>

        <div className="dashboard-content">
          {activeTab === 'Volume Appointment' && (
            <div className="hospital-dashboard">
              <div className="hospital-dashboard__header">
                <div className="hospital-dashboard__filters">
                  <select className="hospital-dashboard__select">
                    <option>Hospital</option>
                  </select>
                </div>
                <div>
                  <select className="hospital-dashboard__select">
                    <option>Période</option>
                  </select>
                  <select className="hospital-dashboard__select">
                    <option>Département</option>
                  </select>
                </div>
                <div
                  className="hospital-dashboard__settings-icon"
                  onClick={toggleSettings}
                >
                  ⚙️
                </div>
              </div>

              {isSettingsOpen && (
                <div className="hospital-dashboard__settings-menu">
                  <h3 className="hospital-dashboard__settings-title">Paramètres</h3>
                  <ul className="hospital-dashboard__settings-list">
                    {Object.keys(detailsData).map((detail) => (
                      <li
                        key={detail}
                        className="hospital-dashboard__settings-item"
                        onClick={() => handleDetailSelect(detail)}
                      >
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="hospital-dashboard__chart-container charbar">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={selectedDetail ? detailsData[selectedDetail].data : [
                      { month: 'Jan', volume: 120 },
                      { month: 'Fev', volume: 100 },
                      { month: 'Mar', volume: 140 }
                    ]}
                  >
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Bar
                      dataKey="volume"
                      fill={selectedDetail ? detailsData[selectedDetail].color : '#8884d8'}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>

              {selectedDetail && (
                <div className="hospital-dashboard__chart-title">
                  {selectedDetail}
                </div>
              )}

              <div className="hospital-dashboard__analysis">
                <h3 className="hospital-dashboard__analysis-title">Analyse Automatique</h3>
                <p className="hospital-dashboard__analysis-text">+113 % de nouveaux patients cette semaine</p>
              </div>

              <div className="hospital-dashboard__actions">
                <button className="hospital-dashboard__button hospital-dashboard__button--pdf">PDF</button>
                <button className="hospital-dashboard__button hospital-dashboard__button--excel">Excel</button>
              </div>
            </div>

          )}

          {activeTab === 'Use Service' && (
            <div>
              {/* <div className="dashboard-header">
              <select 
                className="hospital-select"
                value={selectedHospital}
                onChange={(e) => setSelectedHospital(e.target.value)}
              >
                <FaHospital className="select-icon" />
                {hospitals.map(hospital => (
                  <option key={hospital} value={hospital}>{hospital}</option>
                ))}
              </select>

              <div className="dashboard-filters">
                <select 
                  className="filter-select"
                  value={filterBy}
                  onChange={(e) => setFilterBy(e.target.value)}
                >
                  {periods.map(period => (
                    <option key={period} value={period}>{period}</option>
                  ))}
                </select>

                <select 
                  className="filter-select"
                  value={department}
                  onChange={(e) => setDepartment(e.target.value)}
                >
                  {departments.map(dept => (
                    <option key={dept} value={dept}>{dept}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="use-service-chart">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={serviceUseData}>
                  <XAxis dataKey="month" />
                  <YAxis />
                  <Tooltip />
                  <Line type="monotone" dataKey="usage" stroke="#44C4E3" strokeWidth={3} dot={false} />
                </LineChart>
              </ResponsiveContainer>
              <div className="automatic-analysis">
                <p>Analyse automatique</p>
                <p className="analysis-text">+15% de nouveaux services cette semaine</p>
              </div>
              <div className="export-buttons">
                <button className="export-pdf">PDF</button>
                <button className="export-excel">Excel</button>
              </div>
            </div> */}
              <Service />
            </div>
          )}

          {activeTab === 'Patient Trends' && (
            <div className="use-service-chart">
              {<PatientTrends />}
            </div>
          )}
        </div>
      </div>
    </div>

  );
};

export default HospitalDashboard;
